import APP_API from 'api';
import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';

const fields = (role: 'STUDENT' | 'CANDIDATE'): ModalFormFieldTypes[] => [
	{
		name: 'typeID',
		type: 'select',
		dictionaryApiPath: 'applicationTypes',
		label: 'Դիմումի տեսակ',
		colProps: {
			xs: 24,
			lg: 12
		},
		selectProps: {
			className: 'bordered-select'
		},
		visibility: ['ADD', 'VIEW'],
		disabledAt: ['VIEW']
	},
	{
		name: 'userID',
		label: 'Ում է ուղղված',
		type: 'select',
		customApiFetch: {
			path: APP_API[role].SETTINGS.DICT + '/lecturers',
			labelKey: val => `${val.name} ${val.lastname}`,
			valueKey: 'id'
		},
		selectProps: {
			className: 'bordered-select'
		},
		colProps: {
			xs: 24,
			lg: 12
		},
		visibility: ['ADD', 'VIEW'],
		disabledAt: ['VIEW']
	},
	{
		type: 'textArea',
		name: 'application',
		label: 'Դիմումի տեքստ',
		textAreaProps: {
			rows: 6,
			className: 'ant-textarea bordered-textArea'
		},
		colProps: {
			xs: 24,
			lg: 24
		},
		visibility: ['ADD', 'VIEW'],
		disabledAt: ['VIEW']
	},
	{
		type: 'textArea',
		name: 'response',
		label: 'Դիմումի պատասխան',
		textAreaProps: {
			rows: 6,
			className: 'ant-textarea bordered-textArea'
		},
		colProps: {
			xs: 24,
			lg: 24
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		type: 'file',
		name: 'path',
		label: 'Կից փաստաթուղթ',
		isRequired: false,
		colProps: {
			xs: 24,
			lg: 12
		},
		disabledAt: ['VIEW'],
		visibility: ['ADD']
	},
	{
		type: 'select',
		name: 'statusID',
		label: 'Կարգավիճակ',
		dictionaryApiPath: 'applicationStatuses',
		visibility: ['VIEW'],
		selectProps: {
			className: 'bordered-select'
		},
		colProps: {
			xs: 24,
			lg: 12
		},
		disabledAt: ['VIEW']
	}
];

export default fields;
